export default __webpack_public_path__ + "static/SRUS P255 - Product Specifications & Technical Data-a27e981c574463031a9112caf5cc37c9.pdf";